import React, {Component} from "react";
import {connect} from "react-redux";
import * as actions from "../actions/index";
import SimilarBroadcastersList from "../components/SimilarBroadcastersList";
import {checkIfFollowingListAvailable} from "../util/follow_util";
import {
    checkIfSimilarBroadcastersListAvailable,
    checkIfTrendingBroadcastListAvailable,
    formatBroadacastJson,
    getEncryptedIdForBroadcaster,
} from "../util/broadcast_util";
import {
    getCDNImage,
    hideModal,
    isEmpty,
    removeAllModalPopUps,
    resetSearchField,
    showModal,
    vuepayAlert,
} from "../util/utility";
import {getData, LOGIN} from "../util/storage";
import JoinBroadcastConfirmationModal from "../components/modal/JoinBroadcastConfirmationModal";
import {updateJWTToken} from "../util/broadcast/create";
import ViewCardComponent from "../components/ViewCardComponent";
import AwaitingModal from "../components/modal/AwaitingModal";
import RequestJoinAvailabilityModal from "../components/modal/RequestJoinAvailabilityModal";
import CommonConfirmationModal from "../components/modal/CommonConfirmationModal";
//image
import icon_vuepay_white from "../assets/images/icon-vuepay-white@2x.png";
import loading_white_gif from "../assets/gif/loading_white.gif";
import {joinBroadcastError} from "../util/broadcast/join";
import TipModal from "../components/modal/TipModal/TipModal";
import TipResponseModal from "../components/modal/TipResponseModal";
import {getMoneyBloxCurrentWalletBalance, getMoneyBloxWalletUserSessionDetails} from "../assets/libs/MoneyBlox";
import tip_util from "../util/tip/util";

const placeholderDiv = (
    <div
        style={{
            backgroundColor: "#1B75BC",
            height: 400,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
        }}
    >
        <img width={100} src={loading_white_gif}/>
    </div>
);

class BroadcasterDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            broadcaster: undefined,
            noMatch: false,
            requestAvailabilityGroupSession: false,
            requestAvailabilityOneToOneSession: false,
            withdrawType: null,
            tipMessage: null,
            wallet_balance: "0.00",
        };
    }

    getWithDrawConfirmationMessage = () => {
        if(this.state.withdrawType === "group"){
            return "Are you sure you want to cancel group session request?"
        }else{
            return "Are you sure you want to cancel 1-on-1 session request?"
        }
    }
    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        this.setState({
            wallet_balance: this.props.moneyblox.wallet_balance,
        });

        window.scrollTo(0, 0);
        this.props.showLeftBar();
        if (window.location.pathname.indexOf("/broadcast/") >= 0) {
            if (checkIfTrendingBroadcastListAvailable(this.props)) {
                const broadcast_id = this.getValueOfQueryParam();
                if (broadcast_id !== -1) {
                    const broadcastObj = this.props.broadcaster_detail_management.trendingBroadcasters.data.data.find(
                        (obj) => {
                            return obj.id == broadcast_id;
                        }
                    );

                    if (broadcastObj) {
                        this.setState({
                            broadcaster: formatBroadacastJson(broadcastObj),
                            noMatch: false,
                        });
                    }
                } else {
                    this.setState({
                        noMatch: true,
                    });
                }
            } else {
                if (this.getValueOfQueryParam() !== -1) {
                    getData(LOGIN).then((data) => {
                        if (!isEmpty(data)) {
                            this.props.getBroadcastDetail(
                                data.token,
                                data.api_token,
                                this.getValueOfQueryParam()
                            );
                        } else {
                            this.props.getBroadcastDetailGuest(
                                "",
                                "",
                                this.getValueOfQueryParam()
                            );
                        }
                    });
                } else {
                    this.setState({
                        noMatch: true,
                    });
                }
            }
        } else {
            if (!checkIfFollowingListAvailable(this.props)) {
                if (this.getValueOfQueryParam() !== -1) {
                    getData(LOGIN).then((data) => {
                        if (!isEmpty(data)) {
                            this.props.getBroadcasterDetail(
                                data.token,
                                data.api_token,
                                this.getValueOfQueryParam()
                            );
                        }
                    });
                } else {
                    this.setState({
                        noMatch: true,
                    });
                }
            }
        }
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        resetSearchField();
        if (
            nextProps.hasOwnProperty("join_broadcast") &&
            nextProps.join_broadcast.hasOwnProperty("payload") &&
            nextProps.join_broadcast.payload !== null
        ) {
            if (nextProps.join_broadcast.isSuccess) {
                updateJWTToken(nextProps.join_broadcast.payload, () => {
                    removeAllModalPopUps();
                    this.props.initializeTokBox(nextProps.join_broadcast.payload.data);
                    const broadcastID = getEncryptedIdForBroadcaster(
                        this.state.broadcaster.broadcast[0].id
                    );
                    this.props.history.push(
                        `/view/broadcast?session_id=${nextProps.join_broadcast.payload.data.session_id}&broadcast_id=${broadcastID}&token=${nextProps.join_broadcast.payload.data.token}`,
                        {
                            state: {
                                broadcaster: this.state.broadcaster,
                                sessionDetail: nextProps.join_broadcast.payload,
                            },
                        }
                    );
                });
            } else if (nextProps.join_broadcast.isError) {
                getData(LOGIN).then((data) => {
                    if (!isEmpty(data)) {
                        joinBroadcastError(
                            nextProps.join_broadcast.payload,
                            data,
                            this.props
                        );
                        // this.props.getBroadcasterDetail(data.token, data.api_token, this.getValueOfQueryParam())
                    }
                });
            }
            this.props.resetJoinBroadcast();
        }

        //handle request availability request
        if (
            nextProps.availability &&
            nextProps.availability.availabilityBroadcastSuccess
        ) {
            vuepayAlert(
                "success",
                nextProps.availability.availabilityBroadcast.success.message
            );
            nextProps.hideRequestAvailableBroadcasterModal();
            nextProps.showAwaitingAvailableBroadcasterModal();
            nextProps.resetAvaibilityBroadcast();
            this.setState({
                requestAvailabilityGroupSession: false,
                requestAvailabilityOneToOneSession: false,
            });
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    this.props.getBroadcastDetail(
                        data.token,
                        data.api_token,
                        this.getValueOfQueryParam()
                    );
                } else {
                    this.props.getBroadcastDetailGuest(
                        "",
                        "",
                        this.getValueOfQueryParam()
                    );
                }
            });
        } else if (
            nextProps.availability &&
            nextProps.availability.availabilityBroadcastError &&
            nextProps.availability.availabilityBroadcast
        ) {
            vuepayAlert(
                "error",
                nextProps.availability.availabilityBroadcast.response.error.message
            );
            nextProps.hideRequestAvailableBroadcasterModal();
            // nextProps.resetAvaibilityBroadcast();
            this.setState({
                requestAvailabilityGroupSession: false,
                requestAvailabilityOneToOneSession: false,
            });
        }

        // handle withdraw availability request
        if (
            nextProps.availability &&
            nextProps.availability.withdrawAvailabilitySuccess
        ) {
            vuepayAlert(
                "success",
                nextProps.availability.withdrawAvailability.success.message
            );
            nextProps.resetWithdrawAvaibilityBroadcast();
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    this.props.getBroadcastDetail(
                        data.token,
                        data.api_token,
                        this.getValueOfQueryParam()
                    );
                } else {
                    this.props.getBroadcastDetailGuest(
                        "",
                        "",
                        this.getValueOfQueryParam()
                    );
                }
            });
        } else if (
            nextProps.availability &&
            nextProps.availability.withdrawAvailabilityError &&
            nextProps.availability.withdrawAvailability
        ) {
            vuepayAlert(
                "error",
                nextProps.availability.withdrawAvailability.response.error.message
            );
        }

        if (window.location.pathname.indexOf("/broadcast/") >= 0) {
            if (
                nextProps.broadcaster_detail_management &&
                nextProps.broadcaster_detail_management.broadcastDetail != null
            ) {
                if (
                    nextProps.broadcaster_detail_management.broadcastDetail.hasOwnProperty(
                        "data"
                    ) &&
                    nextProps.broadcaster_detail_management.broadcastDetail.data.length >
                    0
                ) {
                    this.setState({
                        broadcaster: formatBroadacastJson(
                            nextProps.broadcaster_detail_management.broadcastDetail.data[0]
                        ),
                        noMatch: false,
                    });
                    this.props.resetBroadcastDetail();
                } else if (
                    nextProps.broadcaster_detail_management.broadcastDetail.error != null
                ) {
                    this.setState({
                        noMatch: true,
                    });
                }
            } else if (checkIfSimilarBroadcastersListAvailable(this.props)) {
                const broadcast_id = this.getValueOfQueryParam(nextProps);

                if (broadcast_id !== -1) {
                    const broadcastObj = this.props.broadcaster_detail_management.similarBroadcasters.data.data.find(
                        (obj) => {
                            return obj.id == broadcast_id;
                        }
                    );

                    if (broadcastObj) {
                        this.setState({
                            broadcaster: broadcastObj,
                            noMatch: false,
                        });
                    }
                } else {
                    this.setState({
                        noMatch: true,
                    });
                }
            }
        } else {
            if (checkIfFollowingListAvailable(nextProps)) {
                const broadcaster_id = this.getValueOfQueryParam(nextProps);
                const broadcasterObj = nextProps.following.followingList.data.data.find(
                    (obj) => {
                        return obj.id == broadcaster_id;
                    }
                );
                if (broadcasterObj) {
                    this.setState({
                        broadcaster: broadcasterObj,
                    });
                }
            } else {
                if (
                    nextProps.broadcaster_detail_management.broadcasterDetail &&
                    nextProps.broadcaster_detail_management.broadcasterDetail.hasOwnProperty(
                        "error"
                    ) &&
                    nextProps.broadcaster_detail_management.broadcasterDetail.error !=
                    null
                ) {
                    this.setState({
                        noMatch: true,
                    });
                } else if (
                    nextProps.broadcaster_detail_management &&
                    nextProps.broadcaster_detail_management.broadcasterDetail
                ) {
                    this.setState({
                        broadcaster:
                        nextProps.broadcaster_detail_management.broadcasterDetail.data,
                        noMatch: false,
                    });

                    this.props.resetBroadcasterDetail();
                }
            }
        }

        if (nextProps.following &&
            nextProps.following.follow_unfollow_data != null &&
            nextProps.following.follow_unfollow_data.hasOwnProperty("success") &&
            !nextProps.following.isFetching &&
            nextProps.following.isSuccess
        ) {
            this.props.resetFollowUnFollowData();
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    this.props.getFollowingList(data.token, data.api_token, "", "");
                }
            });
            this.state.broadcaster.is_following = !this.state.broadcaster
                .is_following;

        }

        tip_util.handleAPIResponse(nextProps);

        if (this.props.moneyblox.wallet_balance !== nextProps.moneyblox.wallet_balance) {
            this.setState({
                wallet_balance: nextProps.moneyblox.wallet_balance,
            });
        }

        //MoneyBlox
        if (nextProps.moneyblox.hasOwnProperty("wallet_balance") &&
            nextProps.moneyblox.hasOwnProperty("user_details") &&
            nextProps.moneyblox.user_details !== null
        ) {

            this.setState({
                wallet_balance: this.props.moneyblox.wallet_balance,
            });
        }
    }

    /**
     *
     * @returns {*}
     */
    getValueOfQueryParam = (objProps) => {
        try {
            let objProp = objProps ? objProps : this.props;
            var decodedString = atob(objProp.match.params.id.toString());
            if (decodedString && decodedString.length > 0) {
                return decodedString.replace("broadcaster_broadcast_", "");
            } else {
                return -1;
            }
        } catch (e) {
            return -1;
        }
    };

    updateRequestAvailabilityGroupSession = () => {
        this.setState({
            requestAvailabilityGroupSession: !this.state
                .requestAvailabilityGroupSession,
        });
    };

    updateRequestAvailabilityOneToOneSession = () => {
        this.setState({
            requestAvailabilityOneToOneSession: !this.state
                .requestAvailabilityOneToOneSession,
        });
    };

    getFormattedTags = () => {
        return this.state.broadcaster.tags
            .map(function (elem) {
                return elem.name;
            })
            .join("; ");
    };

    clickedOnFollowUnfollow = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                if (this.state.broadcaster.is_following) {
                    this.props.unFollowBroadcaster(
                        data.token,
                        data.api_token,
                        this.state.broadcaster.id
                    );
                } else {
                    this.props.followBroadcaster(
                        data.token,
                        data.api_token,
                        this.state.broadcaster.id
                    );
                }
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    setWithdrawType = (type) => {
        this.setState({
            withdrawType: type,
        });
    };

    clickedOnFavNoFav = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                if (this.state.broadcaster.is_following) {
                    this.props.unFollowBroadcaster(
                        data.token,
                        data.api_token,
                        this.state.broadcaster.id
                    );
                } else {
                    this.props.favoriteUser(
                        data.token,
                        data.api_token,
                        this.state.broadcaster.id
                    );
                }
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    requestAvailabilityBroadcast = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let params = {
                    id: this.state.broadcaster.broadcast[0].id,
                    group: this.state.requestAvailabilityGroupSession,
                    onetoone: this.state.requestAvailabilityOneToOneSession,
                    wallet_balance: 1000,
                };
                this.props.requestAvailabilityBroadcast(
                    data.token,
                    data.api_token,
                    params
                );
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    withdrawRequest = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let params;
                this.state.withdrawType === "group"
                    ? (params = {
                        id: this.state.broadcaster.broadcast[0].id,
                        group: true,
                        onetoone: false,
                    })
                    : (params = {
                        id: this.state.broadcaster.broadcast[0].id,
                        group: false,
                        onetoone: true,
                    });
                this.props.withdrawAvailabilityBroadcast(
                    data.token,
                    data.api_token,
                    params
                );
                this.props.hideCommonConfirmationModal();
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    getTagsDataForSimilarBroadcaster = () => {
        const json = {
            broadcaster_id: this.state.broadcaster.id,
            tags: this.state.broadcaster.tags.map(function (elem) {
                return elem.name;
            }),
        };
        return json;
    };

    toggleJoinBroadcastModal = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                const modal = document.getElementById("join-broadcast-confirmation");
                this.setState(
                    {
                        modal: !this.state.modal,
                    },
                    () => {
                        this.state.modal ? showModal(modal) : hideModal(modal);
                    }
                );
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    clickedOnJoinBroadcast = () => {
        // window.scrollTo(0, 0);
        this.state.broadcaster.broadcast[0].broadcast_type === "paid"
            ? this.toggleJoinBroadcastModal()
            : this.apiCallForJoinBroadcast();
    };

    apiCallForJoinBroadcast = () => {
        getData(LOGIN).then((data) => {
            const jsonData = {
                device: this.props.device,
            };
            if (!isEmpty(data)) {
                this.props.joinBroadcast(
                    data.token,
                    data.api_token,
                    this.state.broadcaster.broadcast[0].id,
                    jsonData
                );
            } else {
                if (this.state.broadcaster.age_group === "less_than_12") {
                    this.props.joinBroadcastGuestUser(
                        "",
                        "",
                        this.state.broadcaster.broadcast[0].id,
                        jsonData
                    );
                } else {
                    this.props.history.push({
                        pathname: "/login",
                        state: {basePath: this.props.history.location.pathname},
                    });
                }
            }
        });
    };

    showRequestModal = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.showRequestAvailableBroadcasterModal();
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    __broadCasterState = (broadcaster) => {
        let isInSession =
            broadcaster.broadcast.length > 0 &&
            broadcaster.broadcast[0].broadcast_end_at != "undefined"
                ? true
                : false;
        let response = null;

        if (broadcaster.status === "offline") {
            response = "This broadcaster is currently offline";
        } else if (broadcaster.status === "private") {
            response = "This broadcaster is currently in private session";
        } else if (isInSession === true && broadcaster.status === "online") {
            response = "This broadcaster is online";
        } else if (isInSession === false && broadcaster.status === "online") {
            response = "This broadcaster is online, but currently not in session";
        }

        return (
            <div className="tag-line broadcaster-offline">
                {response}
                <br/>
                <img src={icon_vuepay_white} className="icon"/>
            </div>
        );
    };

    showRequestTipModal = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.showTipModal();
                this.updateWalletBalance();
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    tipRequest = (tipAmount, screen) => {
        let broadcaster_id = this.getValueOfQueryParam()
        let broadcast_id = null;

        if (this.state.broadcaster && this.state.broadcaster.hasOwnProperty("id")) {
            broadcaster_id = this.state.broadcaster.id;

            if (this.state.broadcaster.hasOwnProperty("broadcast") &&
                Array.isArray(this.state.broadcaster.broadcast) &&
                this.state.broadcaster.broadcast.length > 0) {
                broadcast_id = this.state.broadcaster.broadcast[0].id
            }
        }

        tip_util.tipRequest(this.props, tipAmount, screen, broadcaster_id, broadcast_id, () => {
            this.updateWalletBalance();
        })
    };

    updateWalletBalance = () => {
        getMoneyBloxCurrentWalletBalance((wallet_balance) => {
            this.setState({
                wallet_balance: wallet_balance,
            });

            this.props.setWalletBalance(wallet_balance);
        });

        //this updates the redux state
        getMoneyBloxWalletUserSessionDetails(this.props);
    };

    _getType = () => {

        if (this.state.broadcaster &&
            this.state.broadcaster.hasOwnProperty("broadcast") &&
            this.state.broadcaster.broadcast &&
            Array.isArray(this.state.broadcaster.broadcast) &&
            this.state.broadcaster.broadcast.length > 0 &&
            this.state.broadcaster.broadcast[0]) {

            return this.state.broadcaster.broadcast[0].type;
            // if (this.state.broadcaster.broadcast[0].hasOwnProperty("private") && this.state.broadcaster.broadcast[0].private) {
            //     return "private";
            // } else if (this.state.broadcaster.broadcast[0].hasOwnProperty("type")) {
            //     return this.state.broadcaster.broadcast[0].type;
            // }

        }

        return "offline";
    };

    render() {

        return (
            <div>
                {
                    this.state.broadcaster &&
                    this.state.broadcaster.broadcast.length > 0 && (
                        <JoinBroadcastConfirmationModal
                            broadcaster={this.state.broadcaster}
                            hideCrossButton={false}
                            title={"You are entering a paid session"}
                            toggleJoinBroadcastModal={this.toggleJoinBroadcastModal}
                            isVisible={this.state.modal}
                        />
                    )
                }

                <main role="main" className={"broadcast-container-parent"}>
                    <div className="broadcast-container">
                        {this.state.broadcaster && (
                            <div className="row">
                                <div className="col-xl-8 col-lg12">

                                    <ViewCardComponent
                                        // key={currentBroadcast && currentBroadcast.id}
                                        // currentBroadcast={currentBroadcast && currentBroadcast}
                                        join_broadcast={this.props.join_broadcast}
                                        userName={this.state.broadcaster.username}
                                        profilePic={this.state.broadcaster.profile_pic}
                                        status={this.state.broadcaster.statueCode}
                                        type={this._getType()}
                                        channelImage={getCDNImage(
                                            this.state.broadcaster.channel_image.bucket,
                                            this.state.broadcaster.channel_image.key,
                                            566,
                                            400
                                        )}
                                        onlineStatus={true}
                                        favoriteUser={this.clickedOnFavNoFav}
                                        followUnfollow={
                                            this.state.broadcaster.is_following
                                                ? "Unfollow"
                                                : "Follow"
                                        }
                                        onClickFollow={this.clickedOnFollowUnfollow}
                                        onClickJoinBroadcast={this.clickedOnJoinBroadcast}
                                        sessionDescription={
                                            this.state.broadcaster &&
                                            this.state.broadcaster.broadcast.length > 0 &&
                                            this.state.broadcaster.broadcast[0].session_description
                                        }
                                        sessionTitle={
                                            this.state.broadcaster &&
                                            this.state.broadcaster.broadcast.length > 0 &&
                                            this.state.broadcaster.broadcast[0].session_title
                                        }
                                        broadcaster={this.state.broadcaster}
                                        allowOneToOne={
                                            this.state.broadcaster &&
                                            this.state.broadcaster.broadcast.length > 0 &&
                                            this.state.broadcaster.broadcast[0]
                                                .one_to_one_session_allow
                                                ? this.state.broadcaster.broadcast[0]
                                                    .one_to_one_session_price == 0
                                                ? "Free"
                                                : this.state.broadcaster.broadcast[0]
                                                    .one_to_one_session_price
                                                : "N/A"
                                        }
                                        groupSession={
                                            this.state.broadcaster &&
                                            this.state.broadcaster.broadcast.length > 0 &&
                                            this.state.broadcaster.broadcast[0].group_session_price ==
                                            0
                                                ? "Free"
                                                : this.state.broadcaster &&
                                                this.state.broadcaster.broadcast.length > 0 &&
                                                this.state.broadcaster.broadcast[0]
                                                    .group_session_price
                                        }
                                        placeholderDiv={placeholderDiv}
                                        broadcasterStatusOverlay={this.__broadCasterState(
                                            this.state.broadcaster
                                        )}
                                        viewerCount={
                                            this.state.broadcaster &&
                                            this.state.broadcaster.broadcast.length > 0 &&
                                            this.state.broadcaster.broadcast[0].viewers_count
                                        }
                                        showRequestModal={this.showRequestModal}
                                        showRequestTipModal={this.showRequestTipModal}
                                        withdrawRequest={this.withdrawRequest}
                                        showConfirmationModal={
                                            this.props.showCommonConfirmationModal
                                        }
                                        request={
                                            this.state.broadcaster &&
                                            this.state.broadcaster.broadcast.length > 0 &&
                                            this.state.broadcaster.broadcast[0].request
                                        }
                                        tags={this.getFormattedTags()}
                                        setWithdrawType={this.setWithdrawType}
                                    />
                                </div>
                                {this.state.broadcaster.tags && (
                                    <SimilarBroadcastersList
                                        tagsData={this.getTagsDataForSimilarBroadcaster()}
                                        history={this.props.history}
                                    />
                                )}
                            </div>
                        )}

                        {this.state.noMatch && (
                            <div style={{textAlign: "center", marginTop: "100px"}}>
                                <p>No Match found. May be try another broadcaster?</p>
                            </div>
                        )}
                    </div>
                    <AwaitingModal
                        showAwaitingModalFlag={this.props.showAwaitingModalFlag}
                        hideAwaitingModal={this.props.hideAwaitingAvailableBroadcasterModal}
                    />
                    <RequestJoinAvailabilityModal
                        showAvailabilityModalFlag={this.props.showAvailabilityModal}
                        hideRequestAvailabilityModal={
                            this.props.hideRequestAvailableBroadcasterModal
                        }
                        showAwaitingModal={this.props.showAwaitingAvailableBroadcasterModal}
                        requestAvailabilityBroadcast={this.requestAvailabilityBroadcast}
                        updateRequestAvailabilityGroupSession={
                            this.updateRequestAvailabilityGroupSession
                        }
                        updateRequestAvailabilityOneToOneSession={
                            this.updateRequestAvailabilityOneToOneSession
                        }
                        requestAvailabilityGroupSession={
                            this.state.requestAvailabilityGroupSession
                        }
                        requestAvailabilityOneToOneSession={
                            this.state.requestAvailabilityOneToOneSession
                        }
                        balance={this.props.moneyblox.wallet_balance}
                        addBalance={this.props.showMoneyBloxModal}
                        broadcaster={this.state.broadcaster}
                        groupSession={
                            this.state.broadcaster &&
                            this.state.broadcaster.broadcast.length > 0 &&
                            this.state.broadcaster.broadcast[0].group_session_price > 0
                                ? this.state.broadcaster.broadcast[0].group_session_price
                                : "Free"
                        }
                        allowOneToOne={
                            this.state.broadcaster &&
                            this.state.broadcaster.broadcast.length > 0 &&
                            this.state.broadcaster.broadcast[0].one_to_one_session_allow
                                ? this.state.broadcaster.broadcast[0]
                                    .one_to_one_session_price == 0
                                ? "Free"
                                : this.state.broadcaster.broadcast[0].one_to_one_session_price
                                : "N/A"
                        }
                        availability={this.props.availability}
                        request={
                            this.state.broadcaster &&
                            this.state.broadcaster.broadcast.length > 0 &&
                            this.state.broadcaster.broadcast[0].request
                        }
                    />
                    <CommonConfirmationModal
                        content={this.getWithDrawConfirmationMessage()}
                        closeModal={this.props.hideCommonConfirmationModal}
                        confirmFunction={this.withdrawRequest}
                        okayButtonText={"YES"}
                        cancelButtonText={"NO"}
                        commonConfirmationFlag={this.props.commonConfirmationFlag}
                    />
                    {this.props.showTipModalFlag && (
                        <TipModal
                            showTipModalFlag={this.props.showTipModalFlag}
                            hideTipModal={this.props.hideTipModal}
                            balance={this.state.wallet_balance}
                            addBalance={this.props.showMoneyBloxModal}
                            tipRequest={this.tipRequest}
                            tipValue={this.state.tipValue}
                            lowBalanceAlert={this.state.lowBalanceAlert}
                        />
                    )}
                    {
                        this.state.tipMessage &&
                        <TipResponseModal
                            showTipResponseModalFlag={this.props.showTipResponseModalFlag}
                            hideTipResponseModal={this.props.hideTipResponseModal}
                            tipMessage={this.state.tipMessage}
                        />
                    }

                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
        device: state.device.payload,
        following: state.following,
        broadcaster_detail_management: state.broadcaster_detail_management,
        join_broadcast: state.join_broadcast,
        availability: state.availability,
        showAwaitingModalFlag: state.flag.showAwaitingModal,
        showAvailabilityModal: state.flag.showAvailabilityModal,
        showTipModalFlag: state.flag.showTipModalFlag,
        showTipResponseModalFlag: state.flag.showTipResponseModalFlag,
        moneyblox: state.moneyblox,
        commonConfirmationFlag: state.flag.commonConfirmationFlag,
        tip: state.tip,
    };
}

export default connect(mapStateToProps, actions)(BroadcasterDetail);
